import type { ComponentProps } from "react";
import {
    ExclamationCircleIcon,
    ExclamationTriangleIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    StarIcon,
    ChevronRightIcon,
    ClipboardDocumentIcon,
    ArrowTopRightOnSquareIcon,
    ChevronLeftIcon,
    CheckIcon,
    ArrowRightIcon,
} from "@heroicons/react/24/outline";

import { CheckCircleIcon } from "@heroicons/react/24/solid";

type IconName =
    | "CheckCircle"
    | "Error"
    | "Warning"
    | "Info"
    | "KeyboardArrowDown"
    | "Star"
    | "ChevronRight"
    | "Copy"
    | "ArrowTopRightOnSquare"
    | "ChevronLeft"
    | "CheckCircle"
    | "Check"
    | "ArrowRight";

export interface IconProps extends ComponentProps<typeof CheckCircleIcon> {
    name: IconName;
    className?: string;
}

const iconComponents = {
    CheckCircle: CheckCircleIcon,
    Error: ExclamationCircleIcon,
    Warning: ExclamationTriangleIcon,
    Info: InformationCircleIcon,
    KeyboardArrowDown: ChevronDownIcon,
    Star: StarIcon,
    ChevronRight: ChevronRightIcon,
    Copy: ClipboardDocumentIcon,
    ArrowTopRightOnSquare: ArrowTopRightOnSquareIcon,
    ChevronLeft: ChevronLeftIcon,
    Check: CheckIcon,
    ArrowRight: ArrowRightIcon,
} as const;

export function Icon({ name, className = "h-5 w-5", ...props }: IconProps) {
    const IconComponent = iconComponents[name];
    return <IconComponent className={className} {...props} />;
}
